import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTracking } from '@PetSureAustralia/petsure-react-ui-library/distLib/hooks';

export const AddressSearchResult = ({ result, clickHandler }) => {
  const { mainText, secondaryText, reference } = result;

  const resultButton = useRef(null);

  useTracking({
    elementRef: resultButton,
    trackingProps: {
      label: 'Address selection',
      field: {
        inputType: 'button'
      }
    }
  });

  return (
    <button
      ref={resultButton}
      type="button"
      key={reference}
      result={result}
      value={reference}
      onClick={() => clickHandler({ result, inputValue: mainText })}
      onMouseDown={(e) => {
        e.preventDefault();
      }}
    >
      <strong>{mainText}</strong>
      <small>{secondaryText}</small>
    </button>
  );
};

AddressSearchResult.propTypes = {
  result: PropTypes.shape({
    mainText: PropTypes.string,
    secondaryText: PropTypes.string,
    reference: PropTypes.string
  }),
  clickHandler: PropTypes.func
};
